function getDiagramBottomLeft (diagram) {
  const j = diagram.nodes
  let x = null
  let y = null
  while (j.next()) {
    const b = j.value.actualBounds
    if (x === null || b.x < x) {
      x = b.x
    }
    if (y === null || b.y + b.height > y) {
      y = b.y + b.height
    }
  }
  if (x === null) {
    x = 0
  }
  if (y === null) {
    y = 0
  }

  return {x: x, y: y}
}

function getDiagramTopRight (diagram) {
  const db = diagram.documentBounds
  return {x: db.x + db.width + 4, y: db.y + 5}
}

function getDiagramTopLeft (diagram) {
  const db = diagram.documentBounds
  return {x: db.x + 4, y: db.y + 5}
}

function rightOfNode (node) {
  if (node && node.actualBounds) {
    const b = node.actualBounds
    return {x: b.x + b.width, y: b.y}
  } else {
    return {x: 0, y: 0}
  }
}

function isHoveredOver (x) {
  const notHoveredOver = typeof x.tdsIsHoveredOver === 'undefined' || x.tdsIsHoveredOver === null || x.tdsIsHoveredOver === false
  return !notHoveredOver
}

function handleMouseHover (e, part) {
  e.diagram.model.setDataProperty(part.part.data, 'tdsIsHoveredOver', true)
}

function handleMouseLeave (e, part) {
  e.diagram.model.setDataProperty(part.part.data, 'tdsIsHoveredOver', false)
}

export {
  handleMouseHover,
  handleMouseLeave,
  isHoveredOver,
  getDiagramBottomLeft,
  getDiagramTopRight,
  getDiagramTopLeft,
  rightOfNode
}



// WEBPACK FOOTER //
// ./src/graph_parts/common_template_support.js